// @ts-nocheck


import { classesRuntime, statesRuntime } from "../stylable-esm-runtime.js";



var _namespace_ = "common843717652";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"common843717652__root","column":"common843717652__column","fullHeight":"common843717652__fullHeight"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




